export enum InscriptionStatus {
  Registered = 'Registered',
  NotRegistered = 'NotRegistered',
  PermanentNotRegistered = 'PermanentNotRegistered',
  NotAvailable = 'NotAvailable'
}

export enum ExerciseStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Terminated = 'Terminated',
  NotAvailable = 'NotAvailable'
}
export interface GlobalMemberStatus {
  memberId: string;
  interruptionId: string;
  effectiveOn?: Date;
  endOn?: Date;
  effectiveInscriptionStatus: InscriptionStatus;
  effectiveExerciseStatus: ExerciseStatus;
  effectiveInsuranceStatus: ExerciseStatus;
}
